import { render, staticRenderFns } from "./WaitSign.vue?vue&type=template&id=608a2c32&scoped=true"
import script from "./WaitSign.vue?vue&type=script&lang=js"
export * from "./WaitSign.vue?vue&type=script&lang=js"
import style0 from "./WaitSign.vue?vue&type=style&index=0&id=608a2c32&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "608a2c32",
  null
  
)

export default component.exports